import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-free-trial-dialog-box',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatIconModule],
    templateUrl: './free-trial-dialog-box.component.html',
    styleUrl: './free-trial-dialog-box.component.scss'
})
export class FreeTrialDialogBoxComponent {

    constructor(public dialogRef: MatDialogRef<FreeTrialDialogBoxComponent>) { }

    closeDialog() {
        this.dialogRef.close();
    }

    startInterviewPractice() {
        // Add specific logic if needed, for now just closing or logging
        this.dialogRef.close('interview');
    }

    startMockTest() {
        // Add specific logic if needed
        this.dialogRef.close('mock-test');
    }
}
